const CHUNK_LOAD_MARKERS = [
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  // Safari's wording for the same failure.
  "Importing a module script failed",
  "Loading chunk",
  "Loading CSS chunk",
  // Vite's own preload helper, when a screen's stylesheet fails to load.
  "Unable to preload CSS for"
]

// API rejections carry the backend envelope, whose `message` is an object, so a
// bare `message?.includes(...)` throws inside the global handler and buries the
// original rejection.
export const isChunkLoadError = (value: unknown): boolean => {
  const message = (value as { message?: unknown } | null | undefined)?.message

  if (typeof message !== "string") {
    return false
  }

  return CHUNK_LOAD_MARKERS.some((marker) => message.includes(marker))
}

const STYLESHEET_PRELOAD_MARKER = "Unable to preload CSS for"

// Vite's preload helper remembers every stylesheet it has tried, failed or not,
// so importing the screen again skips the one that failed and renders the
// screen without its styles. Only a reload asks for that file again.
export const isStylesheetPreloadError = (value: unknown): boolean => {
  const message = (value as { message?: unknown } | null | undefined)?.message
  return (
    typeof message === "string" && message.includes(STYLESHEET_PRELOAD_MARKER)
  )
}
